import { frontendHostUrl, mixpanelToken } from 'config';
import mixpanel from 'mixpanel-browser';

mixpanel.init(mixpanelToken, { api_host: `${frontendHostUrl}mpl`, ip: false });

const USER_PROPERTIES = Object.freeze({
  ENTREPRENEUR_JOURNEY: 'Entrepreneur Journey',
  FOW: 'Field Of Work',
  ROLE: 'Role',
  CATEGORIES: 'Categories',
});

interface Dict {
  [key: string]: string | number;
}

const analytics_events = {
  track: (event_name: string, props?: Dict) => {
    mixpanel.track(event_name, props);
  },
  identify: (unique_id?: string) => {
    mixpanel.identify(unique_id);
  },
  alias: (unique_id?: string) => {
    mixpanel.alias(unique_id);
  },
  people: {
    set: (props: Dict) => {
      mixpanel.people.set(props);
    },
    set_once: (props: Dict) => {
      mixpanel.people.set_once(props);
    },
    increment: (prop: string, by?: number) => {
      if (by) {
        mixpanel.people.increment(prop, by);
      } else {
        mixpanel.people.increment(prop);
      }
    },
    set_user_info: (answer: string, index: number) => {
      let propertyValue;
      const PropList = [
        USER_PROPERTIES.ENTREPRENEUR_JOURNEY,
        USER_PROPERTIES.FOW,
        USER_PROPERTIES.ROLE,
        USER_PROPERTIES.CATEGORIES,
      ];
      const prop = PropList[index];
      if (index === 3) {
        propertyValue = answer.split(',');
      } else {
        propertyValue = answer;
      }
      mixpanel.people.set({ [prop]: propertyValue });
    },
    update_user_info: (answer: string, item: string) => {
      const rolePropMapping = {
        stage: USER_PROPERTIES.ENTREPRENEUR_JOURNEY,
        fow: USER_PROPERTIES.FOW,
        role: USER_PROPERTIES.ROLE,
      };
      const prop = rolePropMapping[item];
      mixpanel.people.set({ [prop]: answer });
    },
  },
  reset: () => {
    mixpanel.reset();
  },
};

export default analytics_events;
